import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { FulfillmentOpsPage } from "@/features/fulfillment-ops";
import { fulfillmentSearchSchema } from "@/features/fulfillment-ops/fulfillment-route-search";

/** `?id=` deep-links a row's shipment drawer, mirroring `/users?userId=`. */
export const Route = createFileRoute("/fulfillment/")({
  validateSearch: fulfillmentSearchSchema,
  component: FulfillmentRoute,
});

function FulfillmentRoute() {
  return (
    <AdminDashboardShell>
      <FulfillmentOpsPage />
    </AdminDashboardShell>
  );
}
